import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/Rx';
import { ComputeService } from '../../services/compute.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../common/global-variables';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'delete-vdc',
  providers: [
    ComputeService, TranslateService
  ],
  template: require('./vdc-delete.html')
})
export class DeleteVdc {
  @Input('isVisible') isVisible: boolean;
  @Input('vdcData') vdcData;
  @Output('onClose') selfClose = new EventEmitter();

  private subscription: Subscription;
  private active: boolean = true;
  private formData: Object = {};
  private isOperationInProgress: boolean = false;

  constructor(public computeService: ComputeService, private translateService: TranslateService) {
    translateService.use(GlobalVariables.LOCALE);
    this.formData = this.vdcData;
  }
  ngOnInit() {
    this.formData = this.vdcData;
    this.reset();
  }
  ngOnChanges(changes) {
    this.formData = this.vdcData;
    this.reset();
  }
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  cancel() {
    this.closeSelf();
  }
  // Workaround until form has a reset method
  reset() {
    this.active = false;
    setTimeout(() => this.active = true, 0);
  }
  onSubmit(f: NgForm) {
    if ( this.vdcData ) {
        this.deleteVdc(this.vdcData);
    }
  }

  closeSelf() {
    if (this.selfClose) {
      this.selfClose.emit({
        value: 'close'
      });
    }
  }

  deleteVdc(obj) {
    if (obj && obj.vcd && obj.vcd.objectId) {
      this.isOperationInProgress = true;
      this.subscription = this.computeService.deleteVdc(obj.vcd.objectId)
        .subscribe(
          res => {
            this.isOperationInProgress = false;
            this.closeSelf();
          },
          error => {
            this.isOperationInProgress = false;
            this.logError(error, 'delete Vdc');
          },
          () => this.logOperationCompleted('delete Vdc')
        );
    } else {
      this.logError('VDC Id could not be found');
    }
  }
  logError(error, origin: String = '') {
    console.error('Error: ', error, (origin !== '') ? ' Error from ' + origin : '');
  }
  logOperationCompleted(msg: string) {
    this.isOperationInProgress = false;
  }

};




// WEBPACK FOOTER //
// ./src/app/components/compute/compute-vcd/vdc/delete/vdc-delete.component.ts